/**
 * Extract template variable names from a Jinja2 body template or query string.
 * Finds patterns like {{VARIABLE_NAME}}.
 */
export function detectVariables(template: string): string[] {
  if (!template) return [];

  const regex = /\{\{\s*([^}]+?)\s*\}\}/g;
  const variables = new Set<string>();
  let match: RegExpExecArray | null;

  while ((match = regex.exec(template)) !== null) {
    const expression = match[1].trim();
    const fieldName = expression
      .split('|')[0]
      .trim()
      .match(/^[A-Za-z_][A-Za-z0-9_]*/)?.[0];

    if (fieldName) {
      variables.add(fieldName);
    }
  }

  return Array.from(variables);
}

/**
 * Find template variables that don't have corresponding input fields.
 */
export function findUnmappedVariables(
  template: string,
  existingFieldNames: string[]
): string[] {
  const variables = detectVariables(template);
  const fieldSet = new Set(existingFieldNames);
  return variables.filter(v => !fieldSet.has(v));
}
